import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerLicense, Telemetry } from '@syncfusion/ej2-base';
import { enableAlphabeticalDropdownSorting } from './app/shared/util/dropdown-functions';

// Syncfusion 35 sends component telemetry to Application Insights (/v2/track)
// on localhost. That request is blocked in the browser and can stay open for
// minutes inside Angular's zone, which delays grids after their data has loaded.
Telemetry.disable();

//registerLicense('Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXded3RSRWleVk1xVktWYE0=');
registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1JBaF5cXmRCd1p/TH5YfUNzdUVEY1ZUTXxaS1ZhSXxVd0ViW39WcnZWQ2JVVUx9XEs=',
);
enableAlphabeticalDropdownSorting();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
